const repairLogProfile = {
  title: "REPAIR PROFILE",
  tag: "Equipment TAG",
  type: "Equipment Type",
  date: "Date Created",
  createdby: "Created By",
  log: "Log",
  deletebtn: "DELETE REPAIR TASK",
  backbtn: "Go Back"
};

export default repairLogProfile;
